import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  AlertTitle,
} from '@mui/material';

import { DPL_OPTIONS_STATUS, DPL_STATUS_NOTICE, useDplOptions } from '../hooks/useDplOptions';
import texts from '../texts.json';
import SectionCard from './SectionCard';
import LoadingRow from './LoadingRow';
import DplPicker, { dplOptionShape } from './DplPicker';

const SEVERITY_BY_STATUS = {
  [DPL_OPTIONS_STATUS.IDLE]: 'info',
  [DPL_OPTIONS_STATUS.ERROR]: 'error',
  [DPL_OPTIONS_STATUS.EMPTY]: 'warning',
};

const DplSection = ({ coachId, dpl, onChange }) => {
  const { options, status } = useDplOptions(coachId);

  useEffect(() => {
    if (status === DPL_OPTIONS_STATUS.IDLE || status === DPL_OPTIONS_STATUS.LOADING) return;
    onChange((current) => {
      if (options.length === 0) return null;
      if (current && options.some((opt) => opt.contractId === current.contractId)) {
        return current;
      }
      return options[0];
    });
  }, [status, options, onChange]);

  const renderBody = () => {
    const notice = DPL_STATUS_NOTICE[status];
    if (status === DPL_OPTIONS_STATUS.LOADING) {
      return <LoadingRow label={notice.title} />;
    }
    if (notice) {
      return (
        <Alert severity={SEVERITY_BY_STATUS[status]}>
          {notice.helper ? <AlertTitle>{notice.title}</AlertTitle> : notice.title}
          {notice.helper}
        </Alert>
      );
    }
    return (
      <DplPicker
        options={options}
        value={dpl}
        onChange={onChange}
      />
    );
  };

  return (
    <SectionCard title={texts.sections.dpl.title}>
      {renderBody()}
    </SectionCard>
  );
};

DplSection.propTypes = {
  coachId: PropTypes.string,
  dpl: dplOptionShape,
  onChange: PropTypes.func.isRequired,
};

DplSection.defaultProps = {
  coachId: null,
  dpl: null,
};

export default DplSection;
